import {
  Badge,
  Button,
  Group,
  Popover,
  Stack,
  Text,
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { FC, ReactNode, useCallback } from 'react';

interface FilterPopoverShellProps {
  badgeLabel: string;
  children: ReactNode;
  headerActions?: ReactNode;
  isAllSelected: boolean;
  label: string;
  onClose?: () => void;
  title: string;
  width?: number;
}

export const FilterPopoverShell: FC<FilterPopoverShellProps> = ({
  badgeLabel,
  children,
  headerActions,
  isAllSelected,
  label,
  onClose,
  title,
  width = 320,
}) => {
  const [opened, { close, open }] = useDisclosure(false);

  const handleOpenChange = useCallback(
    (isOpen: boolean) => {
      if (isOpen) {
        open();
        return;
      }

      close();
      onClose?.();
    },
    [close, onClose, open],
  );

  return (
    <Popover
      keepMounted={false}
      onChange={handleOpenChange}
      opened={opened}
      position="bottom-end"
      transitionProps={{ duration: 120 }}
      width={width}
    >
      <Popover.Target>
        <Button
          onClick={() => (opened ? close() : open())}
          rightSection={
            <Badge color={isAllSelected ? 'gray' : 'orange'} variant="light">
              {badgeLabel}
            </Badge>
          }
          variant="default"
        >
          {label}
        </Button>
      </Popover.Target>
      <Popover.Dropdown p="sm">
        <Stack gap="sm">
          <Group gap="xs" justify="space-between">
            <Text fw={600} size="sm">
              {title}
            </Text>
            {headerActions ? <Group gap={4}>{headerActions}</Group> : null}
          </Group>
          {children}
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};

export default FilterPopoverShell;
